// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iLf1o","steps":"styles_steps__CgUuS"};